import Vue from 'vue';
import _ from 'lodash';

export default Vue.component('global-tabs', {
  template: require('./template.html'),
  computed: {
    shownTabs() {
      return _.filter(this.tabs, tab => this.hasCondition(tab));
    },
  },
  data() {
    return {
      activeTab: null,
    };
  },
  name: 'global-tabs',
  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => [],
    },
    border: {
      type: String,
      required: false,
      default: '#2d2e33',
    },
    activeOverride: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
    props: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  created() {
    this.activeTab = this.activeOverride || this.shownTabs[0].title;
  },
  methods: {
    setActiveTab(tab) {
      if (tab.disabled) {
        return;
      }
      this.activeTab = tab.title;
    },
    hasCondition(tab) {
      const has = typeof tab.condition !== 'undefined';
      return !has || (has && tab.condition);
    },
  },
});



// WEBPACK FOOTER //
// ./src/mixins/components/tabs/index.js